// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var EPublishActions;
(function (EPublishActions) {
    EPublishActions["PENDING_START_VOTING"] = "pendingStartVotingPeriod";
    EPublishActions["PENDING_PAUSE_VOTING"] = "pendingPauseVotingPeriod";
    EPublishActions["PENDING_STOP_VOTING"] = "pendingStopVotingPeriod";
    EPublishActions["PENDING_PUBLISH_ACTION"] = "pendingPublishAction";
    EPublishActions["PENDING_STOP_KIOSK_ACTION"] = "pendingStopKioskAction";
    EPublishActions["PENDING_GENERATE_INITIALIZATION_REPORT"] = "pendingGenerateInitializationReport";
})(EPublishActions || (EPublishActions = {}));
